/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIamRoleResponse
 */
export interface CreateIamRoleResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateIamRoleResponse
     */
    iamRoleId?: string;
}

export function CreateIamRoleResponseFromJSON(json: any): CreateIamRoleResponse {
    return CreateIamRoleResponseFromJSONTyped(json, false);
}

export function CreateIamRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamRoleResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRoleId': !exists(json, 'iam_role_id') ? undefined : json['iam_role_id'],
    };
}

export function CreateIamRoleResponseToJSON(value?: CreateIamRoleResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_role_id': value.iamRoleId,
    };
}


